import { useAuth } from "./useAuth";
import { useUserType } from "./useUserType";
import { useInvestorSession } from "./useInvestorSession";
import { canAccessMemberModule, isStaffUserType } from "../utils/investorAccess";

/**
 * Auth state for /invest/* module — real investor session OR cooperative member token.
 */
export function useInvestorModuleAuth() {
  const memberToken = useAuth();
  const userType = useUserType();
  const { isMember, isLoggedIn, userType: effectiveType } = useInvestorSession();

  const isStaff = isStaffUserType(userType) && Boolean(memberToken);
  const isMemberInvestor = canAccessMemberModule(userType) && Boolean(memberToken);

  return {
    isLoggedIn: isLoggedIn || isMemberInvestor,
    isMemberInvestor,
    isStaff,
    effectiveUserType: effectiveType,
    memberToken,
    userType,
  };
}
